module.exports = __webpack_public_path__ + "static/img/Thomas-Flegler.3e6fde4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Thomas-Flegler.jpg
// module id = eKx8
// module chunks = 0